// Browser/server value converters. Keep participant hydration and its server-only
// dependency graph out of this module.
const { PROVINCE_CODE_MAP } = require('./participantAddress');
const { mapIlmpBarrierCodes, normaliseIlmpBarrierCode } = require('./ilmpValidationMappings');
const PROVINCES = { NL:'1', NS:'2', NB:'3', PE:'4', QC:'5', ON:'6', MB:'7', SK:'8', AB:'9', NT:'10', BC:'11', YT:'12', US:'13', OT:'14', NU:'16' };
const CHILDCARE = {
  '1':'1','2':'2','3':'3','4':'4','5':'5','6':'6','7':'7', 'not applicable':'1', fnicci:'2',
  'ei/crf':'3','ei-crf':'3',ei_crf:'3', 'provincial funding / subsidy':'4','provincial funding/subsidy':'4',
  'provincial-funding-subsidy':'4',provincial_funding_subsidy:'4', 'no funding received':'5',
  'no-funding-received':'5',no_funding_received:'5', 'daycare space not available':'6',
  'daycare-not-available':'6',daycare_not_available:'6', 'assisted by family / self-funded':'7',
  'assisted-by-family':'7',assisted_by_family:'7','self-funded':'7',self_funded:'7',
};
const text = value => value==null?'':String(value).trim().toLowerCase();
function childcareCode(value) {
  let values=value;
  if(typeof value==='string'&&value.trim().startsWith('[')) { try { values=JSON.parse(value); } catch (_) { return null; } }
  if(!Array.isArray(values)) values=[values];
  if(!values.length) return null;
  const codes=values.map(v=>CHILDCARE[text(v)]||null);
  // Multiple distinct selections cannot be reduced to one ESDC code by guessing.
  return codes.every(Boolean)&&new Set(codes).size===1?codes[0]:null;
}
function provinceCode(value) {
  const key=text(value);
  return PROVINCES[PROVINCE_CODE_MAP[key]||key.toUpperCase()] || (Object.values(PROVINCES).includes(key)?key:null);
}
function employmentCode(value) {
  const key=text(value);
  if(['1','2','9'].includes(key))return key;
  if(['unemployed','underemployed'].includes(key))return '1';
  if(key==='student')return '9';
  return key.startsWith('employed')||['self-employed','self employed','self_employed'].includes(key)?'2':null;
}

module.exports={childcareCode,provinceCode,employmentCode};
